<template>
    <v-container>
        <v-row v-if="currentStats !== null">
            <v-col cols="6" md="3">
                <div class="stat-container">
                    Users: {{ currentStats.tenants_total }}
                </div>
                <div class="stat-container">
                    Active: {{ currentStats.active_tenants }}
                </div>
                <div class="stat-container">
                    Premium: {{ currentStats.premium_tenants }}
                </div>
                <div class="stat-container">
                    Basic: {{ currentStats.basic_tenants }}
                </div>
                <div class="stat-container">
                    Logins this week: {{ currentStats.number_of_logins_for_last_week }}
                </div>
                <div class="stat-container">
                    Total client rev.: {{ currentStats.paid_amount_by_landlord_all_time }}
                </div>
                <div class="stat-container">
                    Total upgrade rev.: {{ currentStats.paid_amount_by_tenants_all_time }}
                </div>
            </v-col>
        </v-row>
        <v-form class="mt-3">
            <v-row class="px-4">
                <v-col>
                    <v-text-field outlined type="number" label="Users" v-model.number="clientStatsNew.users"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Active" v-model.number="clientStatsNew.active"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Upgrades" v-model.number="clientStatsNew.upgrades"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Logins" v-model.number="clientStatsNew.logins"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Promoters" v-model.number="clientStatsNew.promoters"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Neutral" v-model.number="clientStatsNew.neutral"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field outlined type="number" label="Detractors" v-model.number="clientStatsNew.detractors"></v-text-field>
                </v-col>
                <v-col>
                    <v-btn class="mt-2 button-style" @click="addStats" color="error"> 
                    Add data set
                </v-btn>
                </v-col>
            </v-row>
            
        </v-form>
        <v-container>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-data-table multi-sort dense :sort-by.sync="sortBy" :sort-desc="[true]" :headers="headers" :items="statsHistory" :options="options" :loading="loading" loading-text="Getting the client list... Don't be impatient...">
                        <template v-slot:item.action="{ item }">
                            <v-btn dark color="#5D337C" elevation="0" height="28" class="my-2" @click="makeReport(item)"><v-icon small color="white" dark>picture_as_pdf</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
export default {
    name: 'ClientDetails',
    data(){
        return {
            id: this.$route.params.id,
            loading: false,
            sortBy: [ 'realTime' ],
            headers: [
                { text: 'Date', value: 'realTime' },
                { text: 'Users', value: 'users' },
                { text: 'Active', value: 'active' },
                { text: 'Upgrades', value: 'upgrades' },
                { text: 'Logins', value: 'logins' },
                { text: 'NPS', value: 'nps' },
                { text: 'Active %', value: 'activationRate'},
                { text: 'PDF', value: 'action' }
            ],
            options:{
                itemsPerPage: 100
            },
            clientStatsNew: {
                users: 0,
                active: 0,
                upgrades: 0,
                logins: 0,
                promoters: 0,
                neutral: 0,
                detractors: 0
            },
            statsHistory: [],
            currentStats: null
        }
    },
    computed: {
        clientDetails(){ 
            return this.$store.state.currentClient
        }
    },
    methods: {
        getCurrentStats(){
            if(this.clientDetails.userID == null){
                return
            }else{
                axios.get(`https://vaboo.co.uk/admin-api/get-account-kpi/${this.clientDetails.userID}?SONG_OF_THE_MONTH=BIPOLAR-POP_BY_THIRD-REALM_REMIXED_BY-AESTHETHIC-PERFECTION`)
                .then(response => {
                    this.currentStats = response.data.data
                    console.log(response.data.data)
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        getStatsHistory(){
            this.loading = true
            firebase.firestore().collection('clients').doc(this.id).collection('stats').onSnapshot(snapshot => {
                let stats = []
                snapshot.forEach(doc => {
                    let tempStats = doc.data()
                    tempStats.realTime = moment(tempStats.time).format('DD/MM/YY')
                    stats.unshift(tempStats)
                })
                this.statsHistory = stats
                this.loading = false
            }, err => { console.log(`Encountered error: ${err}`) })
        },
        addStats(){
        // set time
            let time = Number(new Date())
            this.clientStatsNew.time = time
        // calc NPS
            let total = this.clientStatsNew.detractors + this.clientStatsNew.neutral + this.clientStatsNew.promoters
            let pp = Math.floor((this.clientStatsNew.promoters / total) * 100)
            let dp = Math.floor((this.clientStatsNew.detractors / total) * 100)
            this.clientStatsNew.nps = (pp - dp)
        // activation rate
            this.clientStatsNew.activationRate = Number(((this.clientStatsNew.active / this.clientStatsNew.users) * 100).toFixed(2))
        // push to db
            firebase.firestore().collection('clients').doc(this.id).collection('stats').doc(time.toString()).set(this.clientStatsNew)
        },
        makeReport(item){
            this.$router.push('/report/' + this.id + '/' + item.time)
        },
        deleteReport(item){
            firebase.firestore().collection('clients').doc(this.id).collection('stats').doc(item.time.toString()).delete()
        }
    },
    mounted(){
        this.getStatsHistory()
        this.getCurrentStats()
    }
}
</script>
<style>
</style>